import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/sections/service-page";
import { pageData } from "@/lib/service-page-data";
const data = pageData["conversion-optimization"];
export const Route = createFileRoute("/marketing/conversion-optimization")({
  component: () => <ServicePage data={data} />,
  head: () => ({
    meta: [
      { title: `${data.title} — CoderLity` },
      { name: "description", content: data.sub },
      { property: "og:title", content: `${data.title} — CoderLity` },
      { property: "og:description", content: data.sub },
      { property: "og:url", content: "/marketing/conversion-optimization" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/marketing/conversion-optimization" }],
  }),
});
